export default __webpack_public_path__ + "static/media/telco_icon.088555cd.svg";